export const getJobLabel = job => `${job?.name || ''}${job?.department?.name ? ` (${job.department.name})` : ''}`;
